import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Typography,
    Avatar,
    Grid,
    Table,
    TableBody,
    TableHead,
    TableRow,
    Button,
    CircularProgress,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Snackbar,
    Alert,
    TableCell,
} from "@mui/material";
import { green, orange, purple, red } from "@mui/material/colors";
import Pagination from "../../../Common/Pagination/pagination";
import {
    AssignmentStatus,
    Container,
    ScreeningStatus,
    StatusChip,
    StyledTableCell,
    StyledTypography,
    TableWrapper,
} from './CandidateContent.styles';
import StatusCard from "../../../Common/Card/Card";
import { theme } from "../../../../theme";
import FilterCandidates from "./FilterCandidates";
import NotesPopup from "../AddNotes/NotesPopup";
import NotifyCandidate from "../CandidateExperience/CandidateStatusAction/Notifycandidate";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserAvatar } from "../AssignTask/AssignTask";
import { addCandidateNote, deleteCandidate, getAllPanelMembers, getCandidateNotes, getCandidates, sendNotify, updateCandidateEmail } from "../candidateManagementApi";
import { useSnackbar } from "../../../../Context/SnackbarContext";
import SearchBar from "../../../Common/Search/SearchBar";
import { getEmailTemplates } from "../../Admin/Communication/communicationApi";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import CandidateProfile from "./CandidateProfile";
import { TableDescription, TableRowStyled } from "../../JobManagement/JobListing/JobListing.styles";
import { statusColorMap } from "../../JobManagement/CreateJobPosting/CreateJob/ReadJob";
import { sanitizeContent } from "../../../Common/Sanitize/sanitizeReactQuill";
import { useLoadingBackdrop } from "../../../../Context/LoadingBackdropContext";


interface candidateData {
    MapID: number,
    CandidateNum: number,
    CandidateName: string,
    CandidateEmail: string,
    CandidatePosition: string,
    CandidateFunction: string,
    CandidateRecruiter: string,
    CandidateStatus: string,
    JobNum: number,
    DeletedItem: boolean,
    MatchedPct: number,
    DeletedCandidate: boolean,
    HasNotes: boolean,
    PhoneNumber: string | null
}

export interface CandidateNotesProps {
    MapID: number;
    NoteValue: string;
    RecruiterName: string;
}

export interface emailTemplate {
    EmailNum: number;
    EmailSubject: string;
    EmailBody: string,
    EmailKey: string
}
export interface CandidateFiters {
    recruiter: string;
    functionName: string;
    position: string;
    sortByStatus: string[];
    matchFilter: string | null
}

export interface PannelMembersType {
    ParticipantID: number,
    EmailId: string,
    UserName: string,
    RoleName: string
}

export const toTitleCase = (name: string): string => {
    return name
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}


const CandidateContent: React.FC = () => {
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCandidates, setTotalCandidates] = useState(0)
    const [candidateList, setCandidateList] = useState<candidateData[]>([])
    const [emailData, setEmailData] = useState<emailTemplate[]>([])
    const [isNotifyDialogOpen, setNotifyDialogOpen] = useState(false);
    const [isNotesDialogOpen, setNotesDialogOpen] = useState(false);
    const [selectedCandidateId, setSelectedCandidateId] = useState<number | null>(null); // State for selected candidate ID
    const [candidateStatus, setCandidateStatus] = useState('')
    const [isCandidateProfileOpen, setIsCandidateProfileOpen] = useState(false);


    // const handlePageChange = (newPage: number) => setPage(newPage);
    const [candidateEmail, setCandidateEmail] = useState('')
    const [candidateName, setCandidateName] = useState('')
    const [recruiterName, setRecruiterName] = useState('')
    const [candidatePhoneNumber, setCandidatePhoneNumber] = useState<string | null>(null)
    const [candidateJobNum, setCandidateJobNum] = useState<number | null>(null)
    const [candidateMapID, setCandidateMapID] = useState<number | null>(null)
    const [candidatePosition, setCandidatePosition] = useState('')
    const handleNotifyDialogClose = () => setNotifyDialogOpen(false);
    const [notes, setNotes] = useState<CandidateNotesProps[]>([])
    const { tenant } = useParams<{ tenant: string }>();
    const [loading, setLoading] = useState(true)
    const [notesLoading, setNotesLoading] = useState(false)
    const [activeFilter, setActiveFilter] = useState<string | null>(null)
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false); // For delete confirmation dialog
    const [MapIdToDelete, setMapIdToDelete] = useState<number | null>(null)
    const [candidatesCount, setCandidatesCount] = useState({ activeCandidates: 0, screeningCandidates: 0, shortlistedCandidates: 0, interviewCandidates: 0, offerLetterCandidates: 0 })
    const [candidateFilters, setCandidateFilters] = useState<CandidateFiters>({
        recruiter: '',
        functionName: '',
        position: '',
        sortByStatus: [],
        matchFilter: null
    })
    const [searchQuery, setSearchQuery] = useState('')
    const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const isFirstRender = useRef(true);
    const { showSnackbar } = useSnackbar();
    const [pannelMembersdropdown, setPannelMembersDropdown] = useState<PannelMembersType[]>([])
    const columnData = ["Candidate Name", "Job Title", "Eko Matching", "Department", "Recruiter", "Notes", "Action", "Status", "Delete"]

    const location = useLocation();
    const navigate = useNavigate();
    const { jobNum, mapId } = location.state || {};
    const { show, hide } = useLoadingBackdrop();

    const handleNotifyDialogOpen = (email: string, candidateNum: number, status: string, candidateName: string, recruiterName: string, jobnum: number, mapId: number, candidatePosition: string) => {
        setNotifyDialogOpen(true); setCandidateEmail(email); setSelectedCandidateId(candidateNum); setCandidateStatus(status); setCandidateName(candidateName); setRecruiterName(recruiterName); setCandidateJobNum(jobnum); setCandidateMapID(mapId); setCandidatePosition(candidatePosition)
    };

    const fetchCandidates = async (filters: CandidateFiters, page: number, rowsPerPage: number, searchQuery: string) => {
        try {
            setLoading(true)

            const payLoad = {
                page: page,
                rowsPerPage: rowsPerPage,
                recruiter: filters.recruiter,
                functionName: filters.functionName,
                position: filters.position,
                sortByStatus: filters.sortByStatus,
                matchFilter: filters.matchFilter,
                candidateName: searchQuery,
                mapId: mapId,
                jobNum: jobNum
            }
            const response = await getCandidates(tenant, payLoad)
            if (response) {
                const data: candidateData[] = Array.isArray(response.Candidates) ? response.Candidates : []; // Ensure it's an array
                setCandidateList(data)
                setTotalCandidates(response.TotalCandidates)
                setCandidatesCount({
                    activeCandidates: response.ActiveCandidates || 0,
                    screeningCandidates: response.ScreeningCandidates || 0,
                    shortlistedCandidates: response.ShortlistedCandidates || 0,
                    interviewCandidates: response.InterviewCandidates || 0,
                    offerLetterCandidates: response.OfferLetterCandidates || 0
                });

            }
        } catch (error) {
            console.log(error)
        }
        finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        if (location.state) {
            // Replace history with same path but no state to "clear" it
            navigate(location.pathname, { replace: true });
        }
    }, [location.state, navigate]);

    const fetchAllPanelMembers = async () => {
        const result = await getAllPanelMembers(tenant)
        setPannelMembersDropdown(result)
    }

    const fetchEmailTamplates = async () => {
        const result = await getEmailTemplates(tenant)
        setEmailData(result)
    }

    useEffect(() => {
        fetchEmailTamplates()
        fetchAllPanelMembers()
    }, [tenant])

    useEffect(() => {
        fetchCandidates(candidateFilters, page, rowsPerPage, searchQuery)
    }, [page, rowsPerPage])

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return; // 🚫 Skip on initial render
        }

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        searchTimeoutRef.current = setTimeout(() => {
            const updatedFilters = {
                ...candidateFilters,
            };
            fetchCandidates(updatedFilters, page, rowsPerPage, searchQuery);
        }, 300);

        return () => {
            if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        };
    }, [searchQuery]);

    const hasActiveFilters = (filters: typeof candidateFilters): boolean => {
        return (
            filters.recruiter.trim() !== '' ||
            filters.functionName.trim() !== '' ||
            filters.position.trim() !== '' ||
            filters.sortByStatus.length > 0 ||
            filters.matchFilter !== null
        );
    };



    const fetchCandidateNotes = async (status: string, candidateName: string, mapId: number) => {
        setNotesDialogOpen(true);
        setCandidateMapID(mapId)
        setCandidateName(candidateName)
        setCandidateStatus(status)
        try {
            setNotesLoading(true)
            const result = await getCandidateNotes(tenant, mapId)
            setNotes(result)
        } catch (error) {
            console.log(error)
        } finally {
            setNotesLoading(false)
        }

    }



    const handleDeleteJob = (mapId: number) => {
        setMapIdToDelete(mapId); // Set job ID to delete
        setDeleteDialogOpen(true); // Open delete confirmation dialog
    };

    const confirmDeleteCandidate = async () => {
        if (!MapIdToDelete) {
            return
        }
        const payLoad = {
            "MapID": MapIdToDelete
        }
        setDeleteDialogOpen(false);
        const result = await deleteCandidate(tenant, payLoad)
        if (result) {
            showSnackbar("Candidate deleted successfully.", "success")
            fetchCandidates(candidateFilters, page, rowsPerPage, searchQuery)
        }
        else {
            showSnackbar("Failed to delete. Please try again.", "error")
        }

        setMapIdToDelete(null); // Reset job ID to delete
    }

    const cancelDeleteJob = () => {
        setDeleteDialogOpen(false); // Close delete dialog without deleting
        setMapIdToDelete(null); // Reset job ID to delete
    }

    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };


    const [dialogOpenFilter, setDialogOpenFilter] = useState(false);
    const handleRowsPerPageChange = (newRowsPerPage: number) => {
        setRowsPerPage(newRowsPerPage);
        setPage(1); // Reset to first page after changing rows per page
    };


    const statusOptions = [
        { value: 'Screening', label: 'Screening' },
        { value: 'Shortlisted', label: 'Shortlisted' },
        { value: 'HR Interview', label: 'HR Interview' },
        { value: 'Assessment', label: 'Assessment' },
        { value: 'Panel Interview', label: 'Panel Interview' },
        { value: 'Preboarding', label: 'Preboarding' },
        { value: 'On Hold', label: 'On Hold' },
        { value: 'Rejected', label: 'Rejected' }
    ];

    // Calculate pipeline stats based on filteredData
    const pipelineStats = [
        {
            title: "Active",
            count: candidatesCount.activeCandidates, // Only non-deleted candidates
            color: purple[500],
            filterOption: 'Active'
        },
        {
            title: "Shortlisted",
            count: candidatesCount.shortlistedCandidates,
            color: orange[500],
            filterOption: 'Shortlisted'
        },
        {
            title: "Screening",
            count: candidatesCount.screeningCandidates,
            color: green[500],
            filterOption: 'Screening'
        },
        {
            title: "Interview",
            count: candidatesCount.interviewCandidates,
            color: red[500],
            filterOption: 'Interview'
        },
        {
            title: "Offer Letter",
            count: candidatesCount.offerLetterCandidates,
            color: red[500],
            filterOption: 'Offer Letter'
        },
    ];



    const handleOpenFilterDialog = () => {
        setDialogOpenFilter(true);
    };

    const handleCloseFilterDialog = () => {
        setDialogOpenFilter(false);
    };


    const handleApplyFilters = (newFilters: any) => {
        const isFiltered = hasActiveFilters(newFilters);
        if (isFiltered) {
            setCandidateFilters(newFilters)
            fetchCandidates(newFilters, 1, 10, searchQuery)
        }

        handleCloseFilterDialog();
    }

    const handleClearFilterAPI = async () => {
        const clearedFilters = {
            recruiter: '',
            functionName: '',
            position: '',
            sortByStatus: [],
            matchFilter: null,
        };
        setCandidateFilters(clearedFilters);
        setActiveFilter(''); // Also clear active card filter if applicable
        fetchCandidates(clearedFilters, 1, 10, searchQuery);
    }

    const handleFilterByCard = (value: string) => {
        if (activeFilter === value) {
            handleClearFilterByCard(); // Automatically clear if same card is clicked
        } else {
            const updatedFilters = {
                ...candidateFilters,
                sortByStatus: [value]
            };
            setActiveFilter(value);
            setCandidateFilters(updatedFilters)
            fetchCandidates(updatedFilters, 1, 10, searchQuery)
        }
    };

    const handleClearFilterByCard = () => {
        setActiveFilter(null); // Clear the filter
        const updatedFilters = {
            ...candidateFilters,
            sortByStatus: [],
        };
        setCandidateFilters(updatedFilters);
        fetchCandidates(updatedFilters, 1, 10, searchQuery);
    }

    const handleSendNotify = async (status: string | null, EmailSubject: string, EmailBody: string, emailNum: number | null) => {
        try {
            const sanitizedValue = sanitizeContent(EmailBody)
            if (!selectedCandidateId || !candidateEmail || !EmailSubject || !sanitizedValue || !status || !candidateName || !candidateJobNum || !candidateMapID) {
                showSnackbar("Please complete all required fields before sending the email.", "error");
                return; // Stop the function if validation fails
            }
            show()
            const payLoad = {
                "CandidateStatusKey": status,
                "CandidateNum": selectedCandidateId,
                "EmailSubject": EmailSubject,
                "EmailBody": EmailBody,
                "EmailID": candidateEmail,
                "JobNum": candidateJobNum,
                "CandidateName": candidateName,
                "MapID": candidateMapID,
                "EmailNum": emailNum
            }
            const result = await sendNotify(tenant, payLoad)
            if (result) {
                if (result.Status) {
                    fetchCandidates(candidateFilters, page, rowsPerPage, searchQuery)
                    setNotifyDialogOpen(false);
                }
                showSnackbar(result.Message, result.Status ? "success" : "error")

            } else {
                showSnackbar("Failed to send email", "error")
                setNotifyDialogOpen(false);

            }
        } catch {
            console.log("error")
        } finally {
            hide()
        }

    }

    const handleCandidateProfile = (
        candidateName: string,
        candidateEmail: string,
        recruiterName: string,
        candidatePosition: string,
        candidateStatus: string,
        candidatePhoneNumber: string | null,
        candidateMapID: number
    ) => {
        setIsCandidateProfileOpen(true);
        setCandidateName(candidateName);
        setCandidateEmail(candidateEmail);
        setRecruiterName(recruiterName);
        setCandidatePosition(candidatePosition);
        setCandidateStatus(candidateStatus);
        setCandidatePhoneNumber(candidatePhoneNumber);
        setCandidateMapID(candidateMapID);
    }








    const handleSaveNote = async (MapID: number | null, noteValue: string) => {
        if (!MapID || noteValue === '') {
            return;
        }
        const payLoad = {
            "MapID": MapID,
            "NoteValue": noteValue
        }
        const result = await addCandidateNote(tenant, payLoad)
        if (result) {
            const newNote = {
                MapID: MapID,
                NoteValue: noteValue,
                RecruiterName: result.recruiterName,
            };

            setNotes((prevNotes) => [
                ...prevNotes,
                newNote, // Add the new note
            ]);

            // ✅ Update HasNotes flag in candidateList
            setCandidateList((prevList) =>
                prevList.map((candidate) =>
                    candidate.MapID === MapID
                        ? { ...candidate, HasNotes: true }
                        : candidate
                )
            );
            showSnackbar("Notes added successfully.", "success")
        } else {
            showSnackbar("Failed to add please try again.", "error")
        }
    }

    const handleSaveEmail = async (payLoad: any) => {
        try {
            const response = await updateCandidateEmail(tenant, payLoad)
            if (response) {
                showSnackbar(response.Message, response.Status ? "success" : "error");
                if (response.Status) {
                    setCandidateList((prevList) =>
                        prevList.map((candidate) =>
                            candidate.CandidateNum === selectedCandidateId
                                ? { ...candidate, CandidateEmail: payLoad.CandidateEmail }
                                : candidate
                        )
                    );
                }
                return response.Status
            }
            return false
        } catch (error) {
            showSnackbar("Failed to update email.", "error");
            console.log(error)
        }
        return false
    }


    return (
        <Container sx={{
            '& .MuiBox-root': { padding: 0 }, marginLeft: '2.3vw',
            marginRight: '1.3vw',
        }}>
            <Box p={3} >
                <Typography variant="h5" sx={{ fontSize: '2.4vh', fontWeight: 'bold' }}>Hiring Pipeline</Typography>
                <Typography variant="subtitle1" mb={2}>
                    Track the Number of Candidates at Each Stage of the Hiring Process
                </Typography>

                {/* Pipeline Stats */}
                <Grid container spacing={2} sx={{ mb: 2, display: 'flex', flexFlow: 'row', justifyContent: 'space-between', marginTop: '1.66vw', marginBottom: '1.66vw' }}>
                    {pipelineStats.map((stat, index) => (
                        <Grid item xs={4} key={index}>
                            <StatusCard title={stat.title} count={stat.count} filterOption={stat.filterOption}
                                handleFilterByCard={handleFilterByCard}
                                cardfilter={activeFilter === stat.filterOption} />
                        </Grid>
                    ))}
                </Grid>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                    flexWrap: 'wrap',
                    mb: '1.66vw',
                    gap: 2
                }}>

                    <Typography variant="h5" sx={{ fontSize: '2.4vh', fontWeight: 'bold' }}>Candidates List</Typography>

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <SearchBar
                            searchQuery={searchQuery}
                            setSearchQuery={setSearchQuery}
                            placeholder="Search by Candidate Name"
                        />
                        <Button variant="outlined" sx={{ color: theme.palette.primary.main, borderColor: theme.palette.primary.main }} onClick={handleOpenFilterDialog}>Filter & Sort</Button>
                    </Box>
                </Box>
                <FilterCandidates
                    open={dialogOpenFilter}
                    onClose={handleCloseFilterDialog}
                    onApply={handleApplyFilters}
                    statusOptions={statusOptions}
                    filters={candidateFilters}
                    handleClearFilterAPI={handleClearFilterAPI}
                />

                {/* Candidate List */}
                <TableWrapper elevation={0} sx={{ tableLayout: 'auto', mb: '1.66vw' }}>
                    <Box sx={{ overflowX: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {columnData.map((header, idx) => (
                                        <TableCell
                                            key={header}
                                            sx={{
                                                color: theme.palette.text.secondary,
                                                padding: '8px 12px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '13.89vw',
                                                minWidth: '6.94vw',
                                                textAlign: ['action', 'status', 'notes', 'eko matching', 'delete'].includes(header.toLowerCase()) ? 'center' : 'left',
                                            }}
                                        >
                                            <Typography variant='caption'>
                                                {header.charAt(0).toUpperCase() + header.slice(1).replace(/_/g, ' ')}
                                            </Typography>
                                        </TableCell>
                                    ))}


                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    <TableRow>
                                        <TableCell colSpan={columnData.length} style={{ textAlign: 'center' }}>
                                            <CircularProgress />
                                        </TableCell>
                                    </TableRow>
                                )
                                    : candidateList.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={columnData.length} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                No Candidate Data Available
                                            </TableCell>

                                        </TableRow>
                                    ) : (candidateList.map((candidate, index) => (
                                        <TableRowStyled key={index} iseven={(index % 2 === 0).toString()}>


                                            <TableDescription sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                <Grid container alignItems="center" spacing={1} wrap="nowrap">
                                                    <Grid item>
                                                        <UserAvatar>{candidate.CandidateName[0]}</UserAvatar>
                                                    </Grid>
                                                    <Grid item xs zeroMinWidth>
                                                        <Typography
                                                            variant="body2"
                                                            noWrap={false}
                                                            sx={{
                                                                overflowWrap: 'break-word',
                                                                color: theme.palette.primary.main,
                                                                textDecoration: 'underline',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() =>
                                                                handleCandidateProfile(
                                                                    candidate.CandidateName,
                                                                    candidate.CandidateEmail,
                                                                    candidate.CandidateRecruiter,
                                                                    candidate.CandidatePosition,
                                                                    candidate.CandidateStatus,
                                                                    candidate.PhoneNumber,
                                                                    candidate.MapID
                                                                )
                                                            }
                                                        >
                                                            {toTitleCase(candidate.CandidateName)}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </TableDescription>


                                            <TableDescription sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                {candidate.CandidatePosition || ''}
                                            </TableDescription>

                                            <TableDescription sx={{ whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'center' }}>
                                                <Typography
                                                    variant="body2"
                                                    fontWeight='bold'
                                                >
                                                    {`${Math.round(candidate.MatchedPct || 0)}%`}

                                                </Typography>
                                                {candidate.MatchedPct < 65 ? <Typography color="error" >Unmatched</Typography> : <Typography color={theme.palette.success.main} >Matched</Typography>}
                                            </TableDescription>

                                            <TableDescription sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                {candidate.CandidateFunction || ''}
                                            </TableDescription>
                                            <TableDescription sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                {candidate.CandidateRecruiter}
                                            </TableDescription>

                                            <TableDescription sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                                                <Button
                                                    onClick={() => fetchCandidateNotes(candidate.CandidateStatus, candidate.CandidateName, candidate.MapID)}
                                                    startIcon={
                                                        candidate.HasNotes ? (
                                                            <DescriptionOutlinedIcon sx={{ color: '#6C3EC1' }} />
                                                        ) : (
                                                            <PostAddOutlinedIcon sx={{ color: '#6C3EC1' }} />
                                                        )
                                                    }
                                                    color="primary"
                                                >
                                                    {candidate.HasNotes ? 'View Notes' : 'Add Notes'}
                                                </Button>
                                            </TableDescription>


                                            <TableDescription sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textAlign: 'center' }}>
                                                <Button
                                                    variant="text"
                                                    color="primary"
                                                    onClick={() => { handleNotifyDialogOpen(candidate.CandidateEmail, candidate.CandidateNum, candidate.CandidateStatus, candidate.CandidateName, candidate.CandidateRecruiter, candidate.JobNum, candidate.MapID, candidate.CandidatePosition) }}
                                                    sx={{ gap: 1 }}
                                                >
                                                    <i className="fa-solid fa-list-check"></i>
                                                    Action
                                                </Button>

                                            </TableDescription>


                                            <TableDescription sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textAlign: 'center' }}>
                                                <StatusChip
                                                    bg={statusColorMap[candidate.CandidateStatus].bgColor || "#E3F2FD"}
                                                    border={statusColorMap[candidate.CandidateStatus].borderColor || "#BBDEFB"}
                                                    color={statusColorMap[candidate.CandidateStatus].color || "#1565C0"}
                                                >
                                                    ● {candidate.CandidateStatus}
                                                </StatusChip>
                                            </TableDescription>


                                            <TableDescription sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textAlign: 'center' }}>
                                                <IconButton onClick={() => { handleDeleteJob(candidate.MapID) }} sx={{ color: theme.palette.primary.main }}>
                                                    <i className="fa-solid fa-trash fa-xs"></i>
                                                </IconButton>
                                            </TableDescription>




                                        </TableRowStyled>
                                    )))}
                            </TableBody>
                        </Table>
                    </Box>
                    {totalCandidates > 0 && (
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', position: 'relative', top: '-0.694vw' }}>
                            <Pagination
                                totalRows={totalCandidates}
                                rowsPerPage={rowsPerPage}
                                currentPage={page}
                                onPageChange={handlePageChange}
                                onRowsPerPageChange={handleRowsPerPageChange}
                            />
                        </Box>
                    )}

                </TableWrapper>
            </Box>

            {/* Notify Candidates Dialog */}
            <NotifyCandidate
                open={isNotifyDialogOpen}
                handleSendNotify={handleSendNotify}
                email={candidateEmail}
                setEmail={setCandidateEmail}
                onClose={handleNotifyDialogClose}
                candidateStatus={candidateStatus}
                candidateName={candidateName}
                recruiterName={recruiterName}
                candidatePosition={candidatePosition}
                emailData={emailData}
                candidateJobNum={candidateJobNum}
                pannelMembersdropdown={pannelMembersdropdown}
                selectedCandidateId={selectedCandidateId}
                onEmailSave={handleSaveEmail}
            />

            {/* Notes Dialog */}
            <NotesPopup
                open={isNotesDialogOpen}
                onClose={() => { setNotesDialogOpen(false); }}
                userStatus={candidateStatus ?? ""}
                candidateNotes={notes}
                handleSave={handleSaveNote}
                candidateMapId={candidateMapID}
                candidateName={candidateName}
                notesLoading={notesLoading}
            />

            <CandidateProfile
                open={isCandidateProfileOpen}
                onClose={() => setIsCandidateProfileOpen(false)}
                candidateName={candidateName}
                candidateEmail={candidateEmail}
                recruiterName={recruiterName}
                candidatePosition={candidatePosition}
                candidateStatus={candidateStatus}
                candidatePhoneNumber={candidatePhoneNumber}
                candidateMapID={candidateMapID}
            />

            <Dialog
                open={deleteDialogOpen}
                onClose={cancelDeleteJob}
            >
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this candidate? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDeleteJob} sx={{ color: theme.palette.text.secondary }}>
                        Cancel
                    </Button>
                    <Button onClick={confirmDeleteCandidate} variant="contained"
                        sx={{
                            bgcolor: theme.palette.error.main,
                            '&:hover': {
                                bgcolor: theme.palette.error.dark,
                            },
                        }}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default CandidateContent;
